var map = {
	"./AVAX.svg": 51785,
	"./BNB.svg": 33162,
	"./BTC.svg": 9387,
	"./BUSD.svg": 90592,
	"./DAI.svg": 71005,
	"./DOGE.svg": 94997,
	"./ETH.svg": 72173,
	"./FRAX.svg": 17103,
	"./LINK.svg": 44140,
	"./MATIC.svg": 75513,
	"./SOL.svg": 95732,
	"./USDC.svg": 52327,
	"./USDT.svg": 14966,
	"./WBTC.svg": 15686,
	"./WETH.svg": 70182,
	"./XRP.svg": 12826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43354;